import type {Schema} from 'schemaDefinition/types';
import {getSchemaForMode} from './getSchemaForMode';

export const getSchemaForEdit = (schema: Schema): Schema => {
  return getSchemaForMode('edit', schema);
};
